module.exports = __webpack_public_path__ + "img/mockup-goddyns-home.940f796.png";